{
  "el": {
    "task": {
      "actions": {
        "create": "Εργασία",
        "create_and_send": "Δημιουργία και αποστολή",
        "save_as_draft": "Αποθήκευση ως πρόχειρη",
        "update": "Επεξεργασία εργασίας"
      },
      "attributes": {
        "assignments_count": "Αναθέσεις",
        "category": "Τρόπος ολοκλήρωσης",
        "created_at": "Δημιουργήθηκε",
        "description": "Περιγραφή",
        "title": "Τίτλος",
        "units": "Ακίνητα"
      },
      "categories": {
        "confirmation": "Επιβεβαίωση",
        "upload": "Ανέβασμα εγγράφου"
      },
      "categories_info": {
        "confirmation": "Ο υπεύθυνος τσεκάρει την εργασία μόλις ολοκληρωθεί.",
        "upload": "Ο υπεύθυνος πρέπει να ανεβάσει ένα έγγραφο για να ολοκληρώσει την εργασία."
      },
      "labels": {
        "no_tasks": "Δεν υπάρχουν ακόμη εργασίες για αυτό το έργο.",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "set_all_assignees": "Ορισμός για τον υπεύθυνο | Ορισμός για όλους τους {count} υπευθύνους",
        "still_to_do": "{count} εκκρεμεί | {count} εκκρεμούν",
        "units_count": "{count} ακίνητο | {count} ακίνητα",
        "units_required": "Επίλεξε τουλάχιστον ένα ακίνητο"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
